import { useSelector } from 'react-redux';
import { useMemo } from 'react';

import { filters, keyHash } from '@mssgme/helpers';

export const getProducts = (state) => state.products;

export function useProducts(specifier, selector) {
    const selected = useSelector(selector || getProducts);

    return useMemo(() => {
        if (specifier) {
            const items = filters.filterWithExclusion(selected.items, specifier);

            if (items.length !== selected.items.length) {
                return { ...selected, items };
            }
        }

        return selected;
    }, [selected, keyHash(specifier)]);
}
